import React, { Component } from 'react'
import { Box } from 'reactjs-admin-lte'
import $ from 'jquery'
import { Button, ButtonGroup, FormControl, FormGroup, Form, Tabs, Tab } from 'react-bootstrap'
import FontAwesome from 'react-fontawesome'
import AdminStore from 'stores/AdminStore'
import Select from 'react-select'
import ConfirmPopup from 'component/element/ConfirmPopup'
// import WorkJobAssignTaskModal from '../workdoc/jobcontrol/WorkJobAssignTaskModal'
import EmployeeModal from '../hr/EmployeeModal'
import {connect} from 'react-redux'

const NotificationSystem = require('react-notification-system')
class ConfigMechanicWorkflow extends Component {
    constructor(props) {
      super(props)
      
      this.state = {loading:false,tabKey:0,data:[],oriData:[],work_state:[],ori_work_state:[],show_edit_work_state:[],departments:[],isBtnActive:[],users:[{label:this.props.messages['Select'],value:''}],workStateList:[],showConfirmDel:false,rKey:undefined,sKey:undefined,showAssign:false}
      this.durationUnitList = [{label:this.props.messages['Select'],value:''},{label:this.props.messages['Minute'],value:'min'},{label:this.props.messages['Hour'],value:'hour'},{label:this.props.messages['Day'],value:'day'},{label:this.props.messages['Custom'],value:'custom'}]
    }
  
    componentDidMount() {
        this._notificationSystem = this.refs.notificationSystem
        this.loadData()

        $('body').on('click', ()=> { 
            if ($('.Select').hasClass('is-open'))
              $('.table-responsive').css( "overflow-x", "initial" );
            else
              $('.table-responsive').css( "overflow-x", "auto" );
        });
    }

    newEmptyRow(item) {
        return {active:'0',alert:'',department:'',duration:'',duration_unit:'',employee_id:'',first_name:'',label:item.label,last_name:'',nick_name:'',perm_job_owner:false,perm_taking_car:'',position:'',system_user_id:'',task_seq:'',task_value:item.value,warning:''}
    }    

    loadData() {
        this.setState({loading:true})
        AdminStore.loadConfigMechanicWorkflow((result)=>{
            let data = []
            let isBtnActive = []
            let users = [{label:this.props.messages['Select'],value:''}]
            // users = result.users.map((item,index)=>{
            //     return {label:item.real_name+' - '+item.userid,value:item.userid}
            // })

            let workStateList = [{label:this.props.messages['Select'],value:''}]
            let departments = result.departments
            result.departments.map((item,index)=>{
                workStateList.push({label:item.department,value:item.department})
            })

            let work_state = []
            let show_edit_work_state = []
            result.work_state.forEach((ritem,rindex)=>{
                ritem = Object.assign({department:''}, ritem)
                work_state.push(ritem)
                show_edit_work_state.push(false)

                let newData = {label:ritem.label,value:ritem.value,datalist:[]}
                let btnActive = []
                let taskData = []
                let isValue = false
                result.data.forEach((sitem,sindex)=>{
                    if (sitem.task_value==ritem.value) {
                        taskData.push(sitem)
                        isValue = true
                        btnActive.push({
                            duration: false,
                            alert: false
                        })
                    }  
                })
                if (!isValue) {
                    taskData.push(this.newEmptyRow(ritem))
                    btnActive.push({
                        duration: false,
                        alert: false
                    })
                }    
                
                newData.datalist = taskData
                data.push(newData)
                isBtnActive.push(btnActive)
            })
            this.setState({loading:false,data:data,oriData:JSON.parse(JSON.stringify(data)),isBtnActive:isBtnActive,users:users,work_state:work_state,workStateList:workStateList,departments:departments,show_edit_work_state:show_edit_work_state,ori_work_state:JSON.parse(JSON.stringify(work_state))})
        })
    }

    onAddClick(rindex) {
        let {data,isBtnActive} = this.state
        let item = {label:data[rindex].label,value:data[rindex].datalist[data[rindex].datalist.length-1].task_value}
        data[rindex].datalist.push(this.newEmptyRow(item))
        isBtnActive[rindex].push({
            duration: false,
            alert: false
        })
        this.setState({data:data,oriData:JSON.parse(JSON.stringify(data)),isBtnActive:isBtnActive})
    }

    afterDel(rindex,sindex) {
        let {data,isBtnActive} = this.state
        if (data[rindex].datalist.length==1) {
            let item = {label:data[rindex].label,value:data[rindex].datalist[data[rindex].datalist.length-1].task_value}
            data[rindex].datalist[sindex] = this.newEmptyRow(item)
            isBtnActive[rindex][sindex].duration = false
            isBtnActive[rindex][sindex].alert = false
        } else {
            data[rindex].datalist.splice(sindex,1)
            isBtnActive[rindex].splice(sindex,1)
        }
        this.setState({data:data,oriData:JSON.parse(JSON.stringify(data)),isBtnActive:isBtnActive})
    }

    onDelClick(rindex,sindex) {
        let {data} = this.state
        if (data[rindex].datalist[sindex].task_seq==''||data[rindex].datalist[sindex].task_seq==undefined||data[rindex].datalist[sindex].task_seq==null) {
            this.afterDel(rindex,sindex)
        } else {
            this.setState({showConfirmDel:true,rKey:rindex,sKey:sindex})
        }
    }    

    onConfirmDelClick() {
        let {data,rKey,sKey} = this.state
        AdminStore.delConfigMechanicWorkflow(data[rKey].datalist[sKey].task_seq,(result)=>{
            if (result.status==='OK') {
                this.afterDel(rKey,sKey)
                this.onConfirmHideClick()
            }
        })
    }

    onConfirmHideClick() {
        this.setState({showConfirmDel:false,rKey:undefined,sKey:undefined})
    }

    onAssignTaskSave(items) {
        let {data,rKey,sKey} = this.state
        data[rKey].datalist[sKey].employee_id = items.employee_id
        data[rKey].datalist[sKey].first_name = items.first_name
        data[rKey].datalist[sKey].last_name = items.last_name
        data[rKey].datalist[sKey].nick_name = items.nick_name
        this.setState({data:data,rKey:undefined,sKey:undefined,showAssign:false},()=>{
            this.onSaveClick(rKey,sKey)
        })
    }

    onInputChange(rindex,sindex,field,e) {
        let {data} = this.state
        data[rindex].datalist[sindex][field] = e.target.value
        this.setState({data:data},()=>{
            this.onInputFocus(rindex,sindex,field)
        })
    }

    onInputFocus(rindex,sindex,field) {
        let {data,oriData,isBtnActive} = this.state
        let oriVal = oriData[rindex].datalist[sindex][field]
        let newVal = data[rindex].datalist[sindex][field]
        if (oriVal==newVal)
            isBtnActive[rindex][sindex][field] = false
        else
            isBtnActive[rindex][sindex][field] = true
        this.setState({isBtnActive:isBtnActive})
    }

    onDurationUnitChange(rindex,sindex,e) {
        let {data} = this.state
        data[rindex].datalist[sindex].duration_unit = e.value
        this.setState({data:data})
        this.onSaveClick(rindex,sindex)
    }

    onActiveClick(rindex,sindex) {
        let {data} = this.state
        if (data[rindex].datalist[sindex].active=='1')
            data[rindex].datalist[sindex].active = '0'
        else
            data[rindex].datalist[sindex].active = '1'
        this.setState({data:data})
        this.onSaveClick(rindex,sindex)
    }

    onSystemUserIdChange(rindex,sindex,e) {
        let {data} = this.state
        data[rindex].datalist[sindex].system_user_id = e.value
        this.setState({data:data})
        this.onSaveClick(rindex,sindex)
    }

    onWorkStateListChange(rindex,e) {
        let {work_state} = this.state
        work_state[rindex].department = e.value
        this.setState({work_state:work_state})
        this.onSaveConfigMechanicState(rindex)
    }

    onSaveClick(rindex,sindex,field='') {
        let {data} = this.state
        let postData = data[rindex].datalist[sindex]
        if (postData.employee_id==''||postData.employee_id==undefined||postData.employee_id==null) {
            this._notificationSystem.addNotification({
                title: this.props.messages['Notice'],
                message: this.props.messages['Please Select Employee'],
                level: 'error',
                position: 'tc',        
              })
            return false
        }

        AdminStore.saveConfigMechanicWorkflow(postData.task_seq,postData,(result)=>{
            if (result.status=='OK') {
                this._notificationSystem.addNotification({
                    title: this.props.messages['Notice'],
                    message: this.props.messages['Save Successfully'],
                    level: 'info',
                    position: 'tc',        
                })
                data[rindex].datalist[sindex].task_seq = result.task_seq
                this.setState({data:data,oriData:JSON.parse(JSON.stringify(data))},()=>{
                    if (field=='duration'||field=='alert')
                        this.onInputFocus(rindex,sindex,field)
                })
            } else {
                this._notificationSystem.addNotification({
                    title: this.props.messages['Notice'],
                    message: this.props.messages['Save Failed'],
                    level: 'error',
                    position: 'tc',        
                  })
                return false
            }
        })
    }

    onSaveConfigMechanicState(rindex) {
        let {work_state,show_edit_work_state,data} = this.state
        let postData = {task_value:work_state[rindex].value,task_name:work_state[rindex].label,active:work_state[rindex].active,department:work_state[rindex].department}
        AdminStore.saveConfigMechanicState(postData,(result)=>{
            if (result.status=='OK') {
                show_edit_work_state[rindex] = false
                this.setState({show_edit_work_state:show_edit_work_state,ori_work_state:JSON.parse(JSON.stringify(work_state))})
                this._notificationSystem.addNotification({
                    title: this.props.messages['Notice'],
                    message: this.props.messages['Save Successfully'],
                    level: 'info',
                    position: 'tc',        
                })
                let key = data.findIndex(x => x.value==work_state[rindex].value)
                if (key!=-1) {
                    data[key].label = work_state[rindex].label
                    this.setState({data:data,oriData:JSON.parse(JSON.stringify(data))})
                }    
            } else {
                this._notificationSystem.addNotification({
                    title: this.props.messages['Notice'],
                    message: this.props.messages['Save Failed'],
                    level: 'error',
                    position: 'tc',        
                  })
                return false
            }
        })
    }

    onTabsSelect(e) {
        this.setState({tabKey:e})
    }

    onWorkStateActiveClick(rindex) {
        let {work_state,show_edit_work_state,ori_work_state} = this.state
        if (work_state[rindex].active=='1') {
            work_state[rindex].active = '0'
            show_edit_work_state[rindex] = false
            work_state[rindex].label = ori_work_state[rindex].label
        } else {
            work_state[rindex].active = '1'
        }
        this.setState({work_state:work_state,show_edit_work_state:show_edit_work_state})        
        this.onSaveConfigMechanicState(rindex)
    }

    onWorkStateLabelChange(rindex,e) {
        let {work_state} = this.state
        work_state[rindex].label = e.target.value
        this.setState({work_state:work_state})
    }

    onWorkStateLabelSaveClick(rindex) {
        this.onSaveConfigMechanicState(rindex)
    }

    onShowEditWorkStateLabelClick(rindex) {
        let {show_edit_work_state,ori_work_state,work_state} = this.state
        if (!show_edit_work_state[rindex]) {
            show_edit_work_state[rindex] = true
        } else {
            show_edit_work_state[rindex] = false 
            work_state[rindex].label = ori_work_state[rindex].label
        }      
        this.setState({show_edit_work_state:show_edit_work_state})
    }

    renderRowData() {
        let {data,users,isBtnActive,work_state} = this.state
        let checkActive = work_state.findIndex(x => x.active=='1')
        if (data.length==0||checkActive==-1) {
            return(<tr><td colSpan={7}>{this.props.messages['No Data']}</td></tr>)
        } else {
            return(
                data.map((ritem,rindex)=>{
                    let key = work_state.findIndex(x => x.value==ritem.value)
                    if (work_state[key].active=='1') {
                        return(
                            ritem.datalist.map((sitem,sindex)=>{
                                let title = this.props.messages['Anonymous']
                                if (sitem.employee_id!='')
                                    title = sitem.first_name+' '+sitem.last_name
                                return(
                                    <tr key={rindex+'-'+sindex}>
                                        {sindex==0?<td rowSpan={ritem.datalist.length} className='text-center' style={{verticalAlign:'middle'}}>{ritem.label}</td>:''}
                                        <td className='text-center'>
                                            <Button bsStyle='link' onClick={()=>{this.setState({showAssign:true,rKey:rindex,sKey:sindex})}}>
                                                <FontAwesome name='pencil' />&nbsp;{title}
                                            </Button>
                                            <div className='text-right' style={{position:'relative',cursor:'pointer'}}>
                                                {sindex==0?<FontAwesome style={{position:'absolute',bottom:'-5px',right:(sindex==0&&sitem.task_seq!=''?'30px':'0')}} onClick={this.onAddClick.bind(this,rindex)} className='color-green' name='plus' />:''}
                                                {(sindex>0)||(sindex==0&&sitem.task_seq!='')?<FontAwesome style={{position:'absolute',bottom:'-5px',right:'0'}} onClick={this.onDelClick.bind(this,rindex,sindex)} className='color-red' name='minus' />:''}
                                            </div>
                                        </td>
                                        <td className='text-left'>
                                            <Select 
                                                placeholder={this.props.messages['Select']}
                                                clearable={false}
                                                value={sitem.system_user_id}
                                                options={users}
                                                onChange={this.onSystemUserIdChange.bind(this,rindex,sindex)}
                                            />
                                        </td>
                                        <td className='text-center'>
                                            <Form inline>
                                                <FormGroup>
                                                    <FormControl className='text-center' style={{width:'80px'}} value={sitem.duration} onChange={this.onInputChange.bind(this,rindex,sindex,'duration')} onFocus={this.onInputFocus.bind(this,rindex,sindex,'duration')} />
                                                </FormGroup>{' '}
                                                <Button onClick={this.onSaveClick.bind(this,rindex,sindex,'duration')} style={{display:(isBtnActive[rindex][sindex].duration?'':'none')}} bsSize='sm' bsStyle='success'><FontAwesome name='save' />&nbsp;{this.props.messages['Save']}</Button>
                                            </Form>
                                        </td>
                                        <td className='text-left'>
                                            <Select 
                                                clearable={false}
                                                value={sitem.duration_unit}
                                                options={this.durationUnitList}
                                                onChange={this.onDurationUnitChange.bind(this,rindex,sindex)}
                                            />
                                        </td>
                                        <td className='text-center'>
                                            <Form inline>
                                                <FormGroup>
                                                    <FormControl className='text-center' style={{width:'80px'}} value={sitem.alert} onChange={this.onInputChange.bind(this,rindex,sindex,'alert')} onFocus={this.onInputFocus.bind(this,rindex,sindex,'alert')} />
                                                </FormGroup>{' '}
                                                <Button onClick={this.onSaveClick.bind(this,rindex,sindex,'alert')} style={{display:(isBtnActive[rindex][sindex].alert?'':'none')}} bsSize='sm' bsStyle='success'><FontAwesome name='save' />&nbsp;{this.props.messages['Save']}</Button>
                                            </Form>
                                        </td>
                                        <td className='text-center'>
                                            <ButtonGroup
                                                onClick={this.onActiveClick.bind(this,rindex,sindex)}
                                            >
                                                <Button value={0} bsStyle={sitem.active=='0'?'danger':'default'}>{this.props.messages['Close']}</Button>
                                                <Button value={1} bsStyle={sitem.active=='1'?'success':'default'}>{this.props.messages['Open']}</Button>
                                            </ButtonGroup>
                                        </td>
                                    </tr>
                                )
                            })
                        )
                    }
                })    
            )
        }
    }

    renderRowData2() {
        let {workStateList,work_state,departments,show_edit_work_state} = this.state
        if (work_state.length==0) {
            return(<tr><td colSpan={4}>{this.props.messages['No Data']}</td></tr>)
        } else {
            return(
                work_state.map((ritem,rindex)=>{
                    let department = departments.find((item,index)=>{
                        return item.department==ritem.department
                    })
                    department = (department==undefined?{department:'',employees:[]}:department)
                    return(
                        <tr key={rindex} style={{background:(ritem.active=='1'?'':'rgb(249, 249, 249)')}}>
                            <td className='text-center' style={{verticalAlign:'middle'}}>
                                {!show_edit_work_state[rindex]?
                                <Button disabled={ritem.active=='1'?false:true} bsStyle='link' onClick={this.onShowEditWorkStateLabelClick.bind(this,rindex)}>
                                    <FontAwesome name='pencil' />&nbsp;{ritem.label}
                                </Button>
                                :''}
                                {show_edit_work_state[rindex]?
                                <Form inline>
                                    <Button bsStyle='link' onClick={this.onShowEditWorkStateLabelClick.bind(this,rindex)}>
                                        <FontAwesome name='pencil' />
                                    </Button>
                                    <FormGroup>
                                        <FormControl className='text-center' value={ritem.label} onChange={this.onWorkStateLabelChange.bind(this,rindex)} />
                                    </FormGroup>{' '}
                                    <Button onClick={this.onWorkStateLabelSaveClick.bind(this,rindex)} bsSize='sm' bsStyle='success'><FontAwesome name='save' />&nbsp;{this.props.messages['Save']}</Button>
                                </Form>
                                :''}
                            </td>
                            <td className='text-left' style={{verticalAlign:'middle'}}>
                                <Select 
                                    disabled={ritem.active=='1'?false:true}
                                    placeholder={this.props.messages['Select']}
                                    clearable={false}
                                    value={ritem.department}
                                    options={workStateList}
                                    onChange={this.onWorkStateListChange.bind(this,rindex)}
                                />
                            </td>
                            <td className='text-center' style={{verticalAlign:'middle'}}>
                            {
                                department.employees.map((item,index)=>{
                                    return(
                                        <div key={index} style={{lineHeight:'1.5'}}>{item.first_name+' '+item.last_name+' '+this.props.messages['Employee ID']+' '+item.employee_id}</div>
                                    )
                                })
                            }
                            </td>
                            <td className='text-center' style={{verticalAlign:'middle'}}>
                                <ButtonGroup
                                    onClick={this.onWorkStateActiveClick.bind(this,rindex)}
                                >
                                    <Button value={0} bsStyle={ritem.active=='0'?'danger':'default'}>{this.props.messages['Close']}</Button>
                                    <Button value={1} bsStyle={ritem.active=='1'?'success':'default'}>{this.props.messages['Open']}</Button>
                                </ButtonGroup>
                            </td>
                        </tr>
                    )
                })
            )
        }
    }

    renderTable() {
        return(
            <div className='table-responsive'>
                <table className='table table-hover table-bordered-solid'>
                    <thead>
                        <tr>
                            <th style={{width:'120px'}} className='text-center'>{this.props.messages['Job Type']}</th>
                            <th style={{width:'150px'}} className='text-center'>{this.props.messages['Employee']}</th>
                            <th style={{width:'130px'}} className='text-center'>{this.props.messages['User In System']}</th>
                            <th style={{width:'80px'}} className='text-center'>{this.props.messages['Deadline']}</th>
                            <th style={{width:'80px'}} className='text-center'>{this.props.messages['Time Unit']}</th>
                            <th style={{width:'80px'}} className='text-center'>{this.props.messages['Notice Before Time']}</th>
                            <th style={{width:'60px'}} className='text-center'>{this.props.messages['Status']}</th>
                        </tr>    
                    </thead>    
                    <tbody>
                        {this.renderRowData()}
                    </tbody>
                </table>
            </div>
        )
    }

    renderTable2() {
        return(
            <div className='table-responsive'>
                <table className='table table-hover table-bordered-solid'>
                    <thead>
                        <tr>
                            <th style={{width:'150px'}} className='text-center'>{this.props.messages['Job Type']}</th>
                            <th style={{width:'150px'}} className='text-center'>{this.props.messages['Responsibility Department']}</th>
                            <th style={{width:'120px'}} className='text-center'>{this.props.messages['Department Employee']}</th>
                            <th style={{width:'50px'}} className='text-center'>{this.props.messages['Job Type Status']}</th>
                        </tr>    
                    </thead>    
                    <tbody>
                        {this.renderRowData2()}
                    </tbody>
                </table>
            </div>
        )
    }

    render() {
        let {loading,tabKey} = this.state
        let {messages} = this.props
        return(
            <div>
                <Tabs onSelect={this.onTabsSelect.bind(this)} activeKey={tabKey} id='config-mechanic'>
                    <Tab eventKey={0} title={messages['Setup Technician']}>
                        <Box loading={loading}>
                            <Box.Body>
                                {this.renderTable()}
                            </Box.Body>
                        </Box>
                    </Tab> 
                    <Tab eventKey={1} title={messages['Setup Responsibility Department']}>
                        <Box loading={loading}>
                            <Box.Body>
                                {this.renderTable2()}
                            </Box.Body>
                        </Box>
                    </Tab>    
                </Tabs>
                {/* <WorkJobAssignTaskModal 
                    ref='taskModal' 
                    show={this.state.showAssign} 
                    title=''
                    showTask={false}
                    showLeader={false}
                    onDelete={this.onDelClick.bind(this,this.state.rKey,this.state.sKey)}
                    onSave={this.onAssignTaskSave.bind(this)}
                    onHide={()=>{this.setState({showAssign:false,rKey:undefined,sKey:undefined})}}
                /> */}
                <EmployeeModal 
                    show={this.state.showAssign} 
                    onSelect={this.onAssignTaskSave.bind(this)} 
                    onHide={()=>{this.setState({showAssign:false,rKey:undefined,sKey:undefined})}}
                />
                <ConfirmPopup
                    show={this.state.showConfirmDel}
                    message={messages['Want To Delete This Item']}
                    onConfirm={this.onConfirmDelClick.bind(this)}
                    onHide={this.onConfirmHideClick.bind(this)}
                />
                <NotificationSystem ref="notificationSystem" />  
            </div>           
        )
    }
}
    
ConfigMechanicWorkflow.defaultProps = {
        
}
       
export default ConfigMechanicWorkflow = connect(
    (state) => ({messages: state.message.view.admin.ConfigMechanicWorkflow}),null,null,{withRef:true}
)(ConfigMechanicWorkflow);


// WEBPACK FOOTER //
// ./src/view/admin/ConfigMechanicWorkflow.js